module.exports = __webpack_public_path__ + "img/luthi-3.d97d4c6d.jpg";